import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { getOrderChipProps } from "../../../utils/processingOrderChipColor";

const columns = [
  { field: "order_number", headerName: "Order ID", width: 120 },
  { field: "store_name", headerName: "Store Name", flex:1 },
  {
    field: "tracking_number",
    headerName: "Tracking Numbers",
    renderCell: (params) => {
      return (
        <div>
          {params?.row?.tracking_numbers &&
            params?.row?.tracking_numbers?.map((tracking, index) => (
              <h6
                style={{
                  color: tracking?.status === "accepted" ? "green" : "tomato",
                }}
              >
                {tracking?.number || tracking?.tracking_number}
              </h6>
            ))}
        </div>
      );
    },
    flex: 1,
  },
  {
    field: "message",
    headerName: "Message",
    renderCell: (params) => {
      return (
        <h6 style={{ lineHeight: "1.5", flexWrap: "wrap" }}>
          {params?.row?.message
            ? params?.row?.message
            : "Tracking number registered"}
        </h6>
      );
    },
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    renderCell: (params) => {
      return { ...getOrderChipProps(params?.row?.status) };
    },
    headerAlign: "center",
    // flex: 1,
  },
];


const MyCustomNoRowsOverlay = () => (
  <div
    style={{
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <h4 style={{ fontSize: "20px", fontWeight: 500, color: "lightgray" }}>
      No Batch Process is Running
    </h4>
  </div>
);
export default function ProcessingOrdersDataTable({ orders }) {
  return (
    <Box sx={{ height: "500px", width: "100%" }}>
      <DataGrid
        getRowHeight={() => "auto"}
        sx={{ ".MuiDataGrid-root": { border: "1px solid #fff" } }}
        components={{
          NoRowsOverlay: MyCustomNoRowsOverlay,
        }}
        rows={orders?.length > 0 ? orders : []}
        columns={columns}
        getRowId={(row) => row._id}
        pageSize={50}
        rowsPerPageOptions={[5]}
        checkboxSelection
        // disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Box>
  );
}
